import { combineReducers } from 'redux';
import auth from './reducers/auth';
import units from './reducers/unit';
import game from './reducers/game';
import levelTest from './reducers/level-test';
import settings from './reducers/settings';
import teacher from './reducers/teacher';
import report from './reducers/report';
import teacherDashboard from './reducers/teacher-dashboard';
import ui from './reducers/ui';
import error from './reducers/error';
import entities from './reducers/entities';
import activityLocations from './reducers/activityLocations';

const rootReducer = combineReducers({
  auth,
  game,
  levelTest,
  settings,
  teacher,
  report,
  teacherDashboard,
  units,
  ui,
  error,
  entities,
  activityLocations,
});

export default rootReducer;
